<template>
  <v-container fill-height cols="12" class="pa-0 dark">
    <swiper dir="rtl" @slideChange="slideSwiped" @touchMove="slideTouchStart" ref="swiper"
            v-if="!currentPresentationEnded" :options="swiperOptions" class="swiper-box">
      <swiper-slide v-for="slide in showedSlides" :key="slide.image" class="swiper-item">
        <div class="swiper-zoom-container">
          <img :src="slide.image">
        </div>
      </swiper-slide>
    </swiper>

    <v-dialog v-model="feedbackMessageVisible" persistent max-width="290">
      <v-card>
        <v-card-title>
          <div class="headline">Thanks for attending</div>
        </v-card-title>

        <v-card-text>
          <div class="grey--text mb-4">Please give the presenter some feedback.</div>
          <v-form>
            <div>Rating</div>

            <v-col>
              <v-icon dark x-large color="primary" v-for="item in 5"
                      :key="item" @click="changeRating(item)">
                  {{rating >= item ? 'star' : 'star_border'}}
              </v-icon>
            </v-col>

            <div>Extra comments</div>
            <v-textarea
                filled
                name="comment"
                hint="Keep it constructive"
                v-model="comment"
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="submitRating">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="endedMessageVisible" persistent max-width="290">
      <v-card>
        <v-card-title>
          <div class="subheading">This presentation has ended</div>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="closePresentation">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="back-action" v-if="!currentPresentationEnded">
      <router-link to="/" tag="div">
        <v-btn text icon color="transparent">
          <v-icon dark x-large color="white">close</v-icon>
        </v-btn>
      </router-link>
    </div>

    <div class="slide-actions" v-if="!currentPresentationEnded">
      <div class="slide-action" @click="toggleFavoriteHandler">
        <v-btn text icon color="transparent">
          <v-icon x-large :color="currentSlideIsFavorite ? 'primary' : 'white'">
            {{currentSlideIsFavorite ? 'star' : 'star_border'}}
          </v-icon>
        </v-btn>
      </div>
    </div>

    <div class="slide-counter" v-if="!currentPresentationEnded">
      <span>{{showedSlideIndex + 1}}</span>
      <span>/</span>
      <span>{{totalSlides}}</span>
    </div>

    <image-preloader v-for="slide in slides" :key="slide.image" :src="slide.image"/>
  </v-container>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { imagePreloader } from 'vue-image-preloader';
import { mapGetters } from 'vuex';

export default {
  name: 'Deck',

  components: {
    swiper,
    swiperSlide,
    imagePreloader
  },

  data() {
    return {
      feedbackMessageVisible: false,
      endedMessageVisible: false,
      rating: 0,
      comment: undefined,
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 30,
        zoom: true
      }
    };
  },

  created() {
    this.$store.dispatch('getCheckedInPresentation', this.$route.params.presentationId);
    alert('hop');
  },

  computed: mapGetters([
    'currentSlideImage',
    'currentSlideIsFavorite',
    'currentPresentationEnded',
    'totalSlides',
    'slides',
    'showedSlides',
    'showedSlideIndex',
    'showFeedback'
  ]),

  watch: {
    currentPresentationEnded(val) {
      this.endedMessageVisible = val && !this.showFeedback;
      this.feedbackMessageVisible = val && this.showFeedback;
    },
    showFeedback(val) {
      this.endedMessageVisible = !val && this.currentPresentationEnded;
      this.feedbackMessageVisible = val && this.currentPresentationEnded;
    }
  },

  methods: {
    toggleFavoriteHandler() {
      const toggle = !this.currentSlideIsFavorite;
      this.$store.dispatch('toggleFavoriteSlide', {
        toggle,
        presentationId: this.$route.params.presentationId
      });
    },

    slideSwiped() {
      this.$store.dispatch('gotoSlide', this.$refs.swiper.swiper.activeIndex);
    },

    slideTouchStart(event) {
      event.preventDefault();
      event.stopPropagation();
    },

    changeRating(rating) {
      this.rating = rating;
    },

    submitRating() {
      this.$store.dispatch('submitRating', {
        presentationId: this.$route.params.presentationId,
        rating: this.rating,
        comment: this.comment
      });
      this.$router.push({ name: 'home' });
    },

    closePresentation() {
      this.$router.push({ name: 'home' });
    }
  }
};
</script>

<style lang="scss" scoped>
  .slide {
    align-self: center;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .slide-img {
    max-width: 100%;
    max-height: 100%;
  }

  .back-action {
    position: absolute;
    top: 2rem;
    left: 1rem;
  }

  .slide-actions {
    position: absolute;
    top: 2rem;
    right: 1rem;
  }

  .slide-action {
    cursor: pointer;
    display: block;
  }

  .slide-action .icon {
    background-color: rgba(0,0,0,0.3);
    border-radius: 5px;
  }

  .slide-counter {
    position: absolute;
    right: 0;
    bottom: 0;
    color: #fff;
    background-color: rgba(0,0,0,0.3);
    padding: 12px;
  }

  .swiper-box {
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }
  .swiper-item {
    height: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Attending.vue